export var languages = [
    { id: 2, shortName: "ru", name: "Russian (RU)", flagicon: "flag-icon-ru", enumId: 0 },
    { id: 4, shortName: "en", name: "English (EN)", flagicon: "flag-icon-um", enumId: 1 },
];